import React, { useEffect } from 'react';
import { notification, Button } from 'antd';
import { CheckCircleOutlined, InfoCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { useAuth } from './AuthContext';
import crossWindowSync from '../../utils/crossWindowSync';
import { logger } from '../../utils/logger';

const AuthSyncNotification = () => {
  const { isAuthenticated } = useAuth();
  const [api, contextHolder] = notification.useNotification();

  useEffect(() => {
    // 監聽跨視窗認證狀態變化
    const handleAuthSync = (authStatus) => {
      logger.log('收到認證同步通知:', authStatus);
      
      if (authStatus.isAuthenticated && authStatus.user) {
        // 用戶在其他視窗登入
        api.success({
          message: '登入同步',
          description: `歡迎回來，${authStatus.user.name || authStatus.user.email}！`,
          icon: <CheckCircleOutlined style={{ color: '#52c41a' }} />,
          placement: 'topRight',
          duration: 6,
          btn: (
            <Button 
              type="primary" 
              size="small" 
              onClick={() => window.location.reload()}
            >
              刷新頁面
            </Button>
          ),
        });
      } else if (!authStatus.isAuthenticated) {
        // 用戶在其他視窗登出
        api.warning({
          message: '登出同步',
          description: '您已在其他視窗登出，此視窗將自動更新。',
          icon: <ExclamationCircleOutlined style={{ color: '#faad14' }} />,
          placement: 'topRight',
          duration: 6,
          btn: (
            <Button 
              type="primary" 
              size="small" 
              onClick={() => window.location.reload()}
            >
              刷新頁面
            </Button>
          ),
        });
      }
    };

    // 監聽頁面可見性變化
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        // 頁面變為可見時，檢查認證狀態
        const currentAuth = crossWindowSync.getCurrentAuthStatus();
        if (currentAuth && currentAuth.isAuthenticated && currentAuth.user) {
          // 如果當前視窗未登入但其他視窗已登入
          if (!isAuthenticated) {
            api.info({
              message: '認證狀態同步',
              description: '檢測到您已在其他視窗登入，正在同步登入狀態...',
              icon: <InfoCircleOutlined style={{ color: '#1890ff' }} />,
              placement: 'topRight',
              duration: 3,
            });
          }
        }
      }
    };

    crossWindowSync.on('auth_status', handleAuthSync);
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      crossWindowSync.off('auth_status', handleAuthSync);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [isAuthenticated, api]);

  return contextHolder;
};

export default AuthSyncNotification; 

